module.exports = __webpack_public_path__ + "static/media/CHOPCA_MENU-normal.7f0bccf4.png";